module.exports = __webpack_public_path__ + "files/SPIADI2025 - Annexe Catheters.4cc5f12cff4d2ba3819b3cdeed3e333e.pdf";